// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-aria-DatePicker .react-aria-DateSegment[data-placeholder],
.react-aria-DatePopover [aria-disabled],
.react-aria-DatePicker .react-aria-DateSegment[data-readonly] {
  color: #949494;
}

.react-aria-DatePopover [aria-disabled] {
  cursor: not-allowed;
}

.react-aria-CalendarHeaderCell {
  text-align: center;
}

.react-aria-DatePopover .react-aria-CalendarCell {
  aspect-ratio: 1/1;
  padding: 4px;
  text-align: center;
  outline: none;
  display: grid;
  place-items: center;
  vertical-align: center;
}

.react-aria-DatePopover [data-selected] {
  color: #fefefe;
  font-weight: bold;
  background: var(--primary);
  border-radius: 2px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/DateField/style.css"],"names":[],"mappings":"AAAA;;;EAGE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".react-aria-DatePicker .react-aria-DateSegment[data-placeholder],\n.react-aria-DatePopover [aria-disabled],\n.react-aria-DatePicker .react-aria-DateSegment[data-readonly] {\n  color: #949494;\n}\n\n.react-aria-DatePopover [aria-disabled] {\n  cursor: not-allowed;\n}\n\n.react-aria-CalendarHeaderCell {\n  text-align: center;\n}\n\n.react-aria-DatePopover .react-aria-CalendarCell {\n  aspect-ratio: 1/1;\n  padding: 4px;\n  text-align: center;\n  outline: none;\n  display: grid;\n  place-items: center;\n  vertical-align: center;\n}\n\n.react-aria-DatePopover [data-selected] {\n  color: #fefefe;\n  font-weight: bold;\n  background: var(--primary);\n  border-radius: 2px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
